import HeroSearchbar from '@components/Searchbar/Hero/Hero';

export default HeroSearchbar;
